import React, { useEffect, useState } from 'react';
import { useAtomValue } from "jotai";
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
// import AppIcons from "../../../assets/images/icons";
import SVGIcons from '../../../assets/images/icons/svgIcons';
import { translateThis } from '../../../helpers/language.helper';

import './services.scss';
import ApiCaller from '../../../services/api/APICaller';
import { authState } from "../../../state/auth.state";
import { USER_ROLES } from "../../../constants";
import ConfirmDialog from "../../../components/dialogs/confirm.dialog";
import S3ImageViewerWithFallback from '../../../components/awsS3ImageViewer/ImgViewerWithFallback';

const Services = () => {
  const navigate = useNavigate();
  const auth = useAtomValue(authState);
  const [isShowAccessDeniedPopup, setIsShowAccessDeniedPopup] = React.useState(false);


  const [dataArr, setDataArr] = useState([]);

  useEffect(() => {
    getDataArr();
  }, [])

  const getDataArr = () => {
    const apiCaller = new ApiCaller('projects/our-projects');
    apiCaller.getList().then(({ data }) => setDataArr(data.result))
  }

  // const serviceItems = [
  //   {
  //     bgImg: AppIcons.oilGas,
  //     title: 'Oil & gas',
  //     id: 'oil_gas',
  //     description: 'Facilitating seamless import and export operations for energy resources.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  //   {
  //     bgImg: AppIcons.hotel,
  //     title: 'Hotel industries',
  //     id: 'hotel_industries',
  //     description: 'Enhancing hospitality with cutting-edge investment strategies.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  //   {
  //     bgImg: AppIcons.green,
  //     title: 'Green industries',
  //     id: 'green_industries',
  //     description: 'Driving environmental innovation for a sustainable future worldwide.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  //   {
  //     bgImg: AppIcons.minerals,
  //     title: 'Minerals',
  //     id: 'minerals',
  //     description: 'Extracting and refining Copper, Iron, Aluminium, Diamonds, and Gold.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  //   {
  //     bgImg: AppIcons.smart,
  //     title: 'Smart cities',
  //     id: 'smart_cities',
  //     description: 'Transforming urban landscapes with intelligent, connected technologies.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  //   {
  //     bgImg: AppIcons.wealth,
  //     title: 'Wealth management',
  //     id: 'wealth_management',
  //     description: 'Expert financial services licensed by FinCEN part of USA Department of Treasury.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  //   {
  //     bgImg: AppIcons.blue,
  //     title: 'Blue industries',
  //     id: 'blue_industries',
  //     description: 'Pioneering advancements in marine and coastal development.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  //   {
  //     bgImg: AppIcons.security,
  //     title: 'Security',
  //     id: 'security',
  //     description: 'Providing secure transportation solutions globally, including aviation and private jet services.',
  //     btn: 'Read More',
  //     link: '/'
  //   },
  // ];

  /**
   * Manages the service click
   * @param {string} serviceId the clicked service
   * @param {string} serviceLink the link of the clicked service
   */
  const onServiceClick = (serviceId, serviceLink, serviceElement) => {
    const membersOnlyServices = ['Security', 'Wealth management'];
    if (auth.userRole !== USER_ROLES.member && membersOnlyServices.includes(serviceId)) {
      setIsShowAccessDeniedPopup(true);
    } else {
      serviceLink = `investments-details/${serviceLink}`;
      const path = serviceLink.startsWith('/') ? serviceLink : `/${serviceLink}`;
      console.log(serviceElement, 'serviceElement')
      navigate(path, { state: {serviceElement} });
    }
  }

  /**
   * Renders the service item
   * @returns JSX
   */
  const renderServiceItem = (element) => (
    <button type='button' onClick={() => onServiceClick(element.title, element.id, element)}>
      <div className="each-service-box f-wrp">
        <span>
          {/* <img src={element.image} alt={element.title} /> */}
          <S3ImageViewerWithFallback fileKey={`${element?.thumbnail}`} />
          <div className='service-con-box'>
            <h2>{translateThis(element.title)}</h2>
            {element.shortDescription ? <p>{translateThis(element.shortDescription)}</p> : null}
            <div className='btn-wrp'>
              <b className='pln-btn'>{translateThis('Read More')} <SVGIcons.LearnMoreArrow /></b>
            </div>
          </div>

        </span>
      </div>
    </button>
  )

  return (
    <>
      <div className='service-block-PC f-wrp'>
        <div className="row">
          {/* {serviceItems.map((element) => (
            <div className={"col-lg-3 col-md-4 col-sm-6 col-xs-12"} key={element.id}>
              {renderServiceItem(element)}
            </div>
          ))} */}

          {dataArr.map((element) => (
            <div className={"col-lg-3 col-md-4 col-sm-6 col-xs-12"} key={element.title}>
              {renderServiceItem(element)}
            </div>
          ))}


        </div>
      </div>

      <div className='service-block-Mob f-wrp'>
        <Swiper
          spaceBetween={20}
          slidesPerView={1}
          modules={[Navigation]}
          navigation
          loop
          // autoplay={{
          //   delay: 7000,
          //   disableOnInteraction: false,
          // }}
          // pagination={{
          //   dynamicBullets: false,
          //   dynamicMainBullets: 0,
          // }}
          className='testimonial-item-wrp'
          breakpoints={{
            10: {
              slidesPerView: 1.2,
              spaceBetween: 15,
            },
            575: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            767: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            900: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
          }}>
          {dataArr.map((element, key) => (
            <SwiperSlide key={key} className="each-testimonials-items f-wrp">
              {renderServiceItem(element)}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {isShowAccessDeniedPopup ? <ConfirmDialog
        isOpen={isShowAccessDeniedPopup}
        onClose={() => {
          setIsShowAccessDeniedPopup(false);
        }}
        title={<span className="popup-title"><SVGIcons.MemberIcon /> &nbsp; {translateThis('Members only')}</span>}
        className={'delete-popup service-access-popup'}
        description={<span>{translateThis('Only members can access this service')}, {translateThis('If you are a member,')} <Link to={'/auth/login'}>{translateThis('sign in')}</Link> </span>}
        // okayButtonText={`${translateThis('Okay')}`}
        cancelButtonText={`${translateThis('close')}`}
        onConfirm={() => setIsShowAccessDeniedPopup(false)}
      /> : null}
    </>
  )
}

export default Services;